import React from 'react';
import { OriginArt } from './cartoon/Art';

const promessas = [
    'Café de produtor, com origem e nota de qualidade',
    'Explicação simples, do grão até a xícara',
    'Pra tomar do seu jeito: coado, prensa francesa ou moka',
];

export default function About() {
    return (
        <section className="lc lc-section bg-preto" id="sobre">
            <div className="lc-wrap lc-grid-2">
                <div>
                    <OriginArt />
                </div>
                <div>
                    <span className="lc-pill" style={{ color: 'var(--lc-lil)' }}>quem somos</span>
                    <h2 className="lc-title">Café especial sem complicação<span className="lc-dot">.</span></h2>
                    <p className="lc-text">
                        A Loop nasceu pra ser a sua porta de entrada no mundo do café especial. Sem esnobismo
                        e sem palavras difíceis: a gente explica tudo do jeito que se fala no dia a dia, pra
                        você trocar o café de mercado por um café de verdade sem medo de errar.
                    </p>
                    <div className="lc-rule" />
                    <ul style={{ listStyle: 'none', margin: 0, padding: 0, display: 'flex', flexDirection: 'column', gap: 16 }}>
                        {promessas.map((item) => (
                            <li key={item} style={{ display: 'flex', gap: 14, alignItems: 'center', fontSize: 18 }}>
                                <span aria-hidden="true" style={{ flex: '0 0 16px', height: 16, background: 'var(--lc-verm)', border: '3px solid #fff' }} />
                                {item}
                            </li>
                        ))}
                    </ul>
                </div>
            </div>
        </section>
    );
}
